<template>
  <Content class="app-container home">
    <div class="station-top">
      <el-row :gutter="12" class="mt5">
        <el-col :span="6">
          <div class="top-item-box item-box-one" style="display: flex;">
            <div style="flex:2;height:100%;">
              <div>今年总数据</div>
              <div style="text-align:center;margin-top:30px;"><span style="font-size:26px;font-weight:bold;">{{formData.total}}</span></div>
            </div>
            <div style="flex:3;display: flex;flex-direction:column;justify-content:space-evenly">
              <div>当月总数据：{{formData.monthTotal}}</div><div>今日新增：{{formData.todayTotal}}</div>
              <div>今日正常：{{formData.todayNormal}}</div><div>今日异常：{{formData.todayAnomaly}}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-item-box item-box-two" style="display: flex;">
            <div style="flex:2;height:100%;">
              <div>ABC表</div>
              <div style="text-align:center;margin-top:30px;"><span style="font-size:26px;font-weight:bold;">{{formData.abcYearTotal}}</span></div>
            </div>
            <div style="flex:3;display: flex;flex-direction:column;justify-content:space-evenly">
              <div>当月总数据：{{formData.abcMonthTotal}}</div><div>今日新增：{{formData.abcTodayTotal}}</div>
              <div>今日正常：{{formData.abcTodayNormal}}</div><div>今日异常：{{formData.abcTodayAnomaly}}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-item-box item-box-three" style="display: flex;">
            <div style="flex:2;height:100%;">
              <div>多动症量表</div>
              <div style="text-align:center;margin-top:30px;"><span style="font-size:26px;font-weight:bold;">{{formData.connerYearTotal}}</span></div>
            </div>
            <div style="flex:3;display: flex;flex-direction:column;justify-content:space-evenly">
              <div>当月总数据：{{formData.connerMonthTotal}}</div><div>今日新增：{{formData.connerTodayTotal}}</div>
              <div>今日正常：{{formData.connerTodayNormal}}</div><div>今日异常：{{formData.connerTodayAnomaly}}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-item-box item-box-four" style="display: flex;">
            <div style="flex:2;height:100%;">
              <div>M-CHAT表</div>
              <div style="text-align:center;margin-top:30px;"><span style="font-size:26px;font-weight:bold;">{{formData.mchatYearTotal}}</span>
              </div>
            </div>
            <div style="flex:3;display: flex;flex-direction:column;justify-content:space-evenly">
              <div>当月总数据：{{formData.mchatMonthTotal}}</div><div>今日新增：{{formData.mchatTodayTotal}}</div>
              <div>今日正常：{{formData.mchatTodayNormal}}</div><div>今日异常：{{formData.mchatTodayAnomaly}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </Content>
</template>
<script>

import {_statistical} from "@/services/index";

export default {
  name: "Index",
  data: () => ({
    formData:{
      total: 0,
      monthTotal: 0,
      todayTotal: 0,
      todayNormal: 0,
      todayAnomaly: 0,
      abcYearTotal: 0,
      abcMonthTotal: 0,
      abcTodayTotal: 0,
      abcTodayNormal: 0,
      abcTodayAnomaly: 0,
      connerYearTotal: 0,
      connerMonthTotal: 0,
      connerTodayTotal: 0,
      connerTodayNormal: 0,
      connerTodayAnomaly: 0,
      mchatYearTotal: 0,
      mchatMonthTotal: 0,
      mchatTodayTotal: 0,
      mchatTodayNormal: 0,
      mchatTodayAnomaly: 0,
    },
  }),
  created() {

  },
  mounted() {
    if (!this.$userSession.checkInstitutionId()){
      return;
    }
    this.statistical();
  },
  methods: {
    statistical(){
      _statistical().then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.formData = res.data;
        }
      }).catch(() => {});
    },
  }
}

</script>

<style scoped>
.app-container {
  min-height: calc(100vh - 130px);
  padding: 5px 12px 0 12px;
}

.top-item-box {
  height: 130px;
  background: #fff;
  margin-bottom: 12px;
  border-radius: 12px;
  color: #fff;
  padding: 16px;
}

.item-box-one {
  background: linear-gradient(30deg, #ed3a60, #f1557a, #f67da0);
  box-shadow: 0 4px 12px #e7cfd6;
}

.item-box-two {
  background: linear-gradient(30deg, #1a94db, #4db1eb, #7acaf9);
  box-shadow: 0 4px 12px #8ed2fa;
}

.item-box-three {
  background: linear-gradient(30deg, #c7a327, #d5ba47, #e3cf65);
  box-shadow: 0 4px 12px #ece7cd;
}

.item-box-four {
  background: linear-gradient(30deg, #6365f7, #9177f1, #cd8ee9);
  box-shadow: 0 4px 12px #dcc9e6;
}

.box-card {
  height: 400px;
  margin-bottom: 12px;
  background-color: #fff;
  border-color: #ebe6f5;
}

.box-card >>> .el-card__body {
  height: 100%;
}

.card-title {
  font-weight: bold;
  height: 30px;
  display: flex;
  align-items: center;
}

.card-title::before {
  content: '';
  height: 70%;
  width: 5px;
  background: #3671e8;
  margin-right: 8px;
}

</style>
